import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { A11yModule } from '@angular/cdk/a11y';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireRemoteConfigModule, DEFAULTS, SETTINGS } from '@angular/fire/compat/remote-config';
import { environment } from '@environment/environment';

const COMPONENTS = [AppComponent];

const MODULES = [
  BrowserModule,
  A11yModule,
  CoreModule,
  AppRoutingModule,
  BrowserAnimationsModule,
  SharedModule,
  AngularFireModule.initializeApp(environment.firebase),
  AngularFireRemoteConfigModule,
];

const PROVIDERS = [
  { provide: DEFAULTS, useValue: { showMosaic: false } },
  { provide: SETTINGS,
      useFactory: () => {
        return isDevMode()
          ? { minimumFetchIntervalMillis: 10000, fetchTimeoutMillis: 10000 }
          : { minimumFetchIntervalMillis: 60000, fetchTimeoutMillis: 10000 };
      }},
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES, BrowserAnimationsModule],
  providers: [...PROVIDERS],
  bootstrap: [AppComponent],
})
export class AppModule {}
